import { OWObject } from "OW.Remoting/Remoting/DataTypes/OWObject";
import { IRequiresActualObject } from "UI/UI/UI/Controls/ControlInterfaces";
import { ControlConnector } from "../ControlConnector";

export class ControlConnectorWithActualObject extends ControlConnector implements IRequiresActualObject {
    /** Aktuálně vybraný aplikační objekt */
    protected _actualObject: OWObject | null = null;

    public get actualObject(): OWObject | null {
        return this._actualObject;
    }

    /**
     * Na konektoru nastaví aktuálně označený/editovaný záznam
     * a vytvoří pro něj nový {@link EditableControlConnector#__dataKey|dataKey}.
     * Pro každý záznam nainicializuje data v reduxu.
     * Pokud nebyl předešlý záznam editován, odstraní data z reduxu.
     * V případě, že je záznam nedefinovaný, nastaví dočasný klíč.
     * @param actualObject
     */
    public set actualObject(actualObject: OWObject | null) {
        this._actualObject = actualObject;
    }
}
